$(function() {
    (function($) {
        // ############################################
        // ############### PRODUCT ZOOM ###############
        // ############################################

        const $body = $('body');
        const $productZoom = $('.product-zoom');
        const $zoomContainer = $productZoom.find('.zoom-img-container');
        const $zoomImg = $zoomContainer.find('.zoom-img');
        const $zoomCloseBtn = $productZoom.find('.zoom-close');
        const zoomContainerEl = $zoomContainer[0];
        const zoomImgEl = $zoomImg[0];

        const thumbnailSelector = '[data-zg-role="thumbnail-zoom"]';
        const mainImageSelector = '#zoomMain img';
        const openZoomMobileSelector = '[data-zg-role="zoom-open"]';

        // --- STATO PINCH-ZOOM (mobile) ---
        const MIN_SCALE = 1;
        const MAX_SCALE = 4;
        const DOUBLE_TAP_SCALE = 2.5;
        let currentScale = 1;
        let startScale = 1;
        let startDistance = 0;
        let currentTranslate = { x: 0, y: 0 };
        let startTranslate = { x: 0, y: 0 };
        let startTouchPoint = { x: 0, y: 0 };
        let lastTapTime = 0;

        function openZoom() {
            $body.addClass('zoom-is-active');
        }

        function closeZoom() {
            $body.removeClass('zoom-is-active');
            $zoomImg.css('object-position', '50% 50%');
            resetPinchZoom();
        }

        function switchImage(imageUrl, $activeThumb) {
            if (!imageUrl) return;

            $zoomImg.attr('src', imageUrl);
            resetPinchZoom();

            $(thumbnailSelector).removeClass('selected');
            if ($activeThumb && $activeThumb.length) {
                $activeThumb.addClass('selected');
            }
        }

        // 1. Mouse sopra una thumbnail
        $(document).on('mouseover', thumbnailSelector, function() {
            const $this = $(this);
            const imageUrl = $this.attr('data-zoom-images');
            switchImage(imageUrl, $this);
        });

        // 2. Click sull'immagine principale
        $(document).on('click', mainImageSelector, function() {
            const imageUrl = $(this).attr('src');
            const $matchingThumb = $(thumbnailSelector).filter('[data-zoom-images="' + imageUrl + '"]').first();

            switchImage(imageUrl, $matchingThumb);
            openZoom();
        });

        // 3. Click sul pulsante di apertura su mobile
        $(document).on('click', openZoomMobileSelector, function() {
            const imageUrl = $(this).attr('data-zoom-images');
            $zoomImg.css('object-position', '50% 50%');
            switchImage(imageUrl, null);
            openZoom();
        });

        // 4. Click sul pulsante di chiusura "X"
        $zoomCloseBtn.on('click', function() {
            closeZoom();
        });

        // 5. Mouse (desktop): pan via object-position, nessun ingrandimento extra
        $zoomContainer.on('mousemove', function(e) {
            if (currentScale !== 1) return; // se per assurdo è rimasto uno zoom touch attivo, non interferire
            e.preventDefault();

            const containerOffset = $zoomContainer.offset();
            const containerWidth = $zoomContainer.width();
            const containerHeight = $zoomContainer.height();
            const x = e.pageX - containerOffset.left;
            const y = e.pageY - containerOffset.top;
            const positionX = Math.min(Math.max((x / containerWidth) * 100, 0), 100);
            const positionY = Math.min(Math.max((y / containerHeight) * 100, 0), 100);

            $zoomImg.css('object-position', positionX + '% ' + positionY + '%');
        });

        // 6. Click sull'immagine zoomata per chiudere (solo se non si sta interagendo col pinch)
        $zoomContainer.on('click', function(e) {
            if (currentScale > 1) return;
            if ($(e.target).is($zoomContainer) || $(e.target).is($zoomImg)) {
                closeZoom();
            }
        });

        // ############################################
        // ######### PINCH-ZOOM / PAN (mobile) #########
        // ############################################

        function getDistance(touches) {
            const dx = touches[0].pageX - touches[1].pageX;
            const dy = touches[0].pageY - touches[1].pageY;
            return Math.sqrt(dx * dx + dy * dy);
        }

        function applyTransform() {
            zoomImgEl.style.transform =
                'translate(' + currentTranslate.x + 'px, ' + currentTranslate.y + 'px) scale(' + currentScale + ')';
        }

        function clampTranslate() {
            const containerWidth = $zoomContainer.width();
            const containerHeight = $zoomContainer.height();
            const maxX = (containerWidth * (currentScale - 1)) / 2;
            const maxY = (containerHeight * (currentScale - 1)) / 2;
            currentTranslate.x = Math.min(Math.max(currentTranslate.x, -maxX), maxX);
            currentTranslate.y = Math.min(Math.max(currentTranslate.y, -maxY), maxY);
        }

        function resetPinchZoom(animate) {
            currentScale = 1;
            currentTranslate = { x: 0, y: 0 };
            if (animate) {
                $zoomImg.addClass('zoom-img--animate');
                setTimeout(() => $zoomImg.removeClass('zoom-img--animate'), 220);
            }
            zoomImgEl.style.transform = 'none';
        }

        if (zoomContainerEl) {
            zoomContainerEl.addEventListener('touchstart', function(e) {
                if (e.touches.length === 2) {
                    startDistance = getDistance(e.touches);
                    startScale = currentScale;
                } else if (e.touches.length === 1) {
                    if (currentScale > 1) {
                        startTranslate = { x: currentTranslate.x, y: currentTranslate.y };
                    }
                    startTouchPoint = { x: e.touches[0].pageX, y: e.touches[0].pageY };

                    // doppio tap: zoom rapido dentro/fuori
                    const now = Date.now();
                    if (now - lastTapTime < 300) {
                        $zoomImg.addClass('zoom-img--animate');
                        if (currentScale > 1) {
                            currentScale = 1;
                            currentTranslate = { x: 0, y: 0 };
                        } else {
                            currentScale = DOUBLE_TAP_SCALE;
                        }
                        applyTransform();
                        setTimeout(() => $zoomImg.removeClass('zoom-img--animate'), 220);
                    }
                    lastTapTime = now;
                }
            }, { passive: true });

            zoomContainerEl.addEventListener('touchmove', function(e) {
                if (e.touches.length === 2) {
                    e.preventDefault();
                    const newDistance = getDistance(e.touches);
                    const scaleDelta = newDistance / startDistance;
                    currentScale = Math.min(Math.max(startScale * scaleDelta, MIN_SCALE), MAX_SCALE);
                    clampTranslate();
                    applyTransform();
                } else if (e.touches.length === 1 && currentScale > 1) {
                    e.preventDefault();
                    const dx = e.touches[0].pageX - startTouchPoint.x;
                    const dy = e.touches[0].pageY - startTouchPoint.y;
                    currentTranslate.x = startTranslate.x + dx;
                    currentTranslate.y = startTranslate.y + dy;
                    clampTranslate();
                    applyTransform();
                }
            }, { passive: false });

            zoomContainerEl.addEventListener('touchend', function(e) {
                if (e.touches.length === 0 && currentScale < MIN_SCALE + 0.05) {
                    resetPinchZoom(true);
                }
            });
        }

    })(jQuery);
});